import React from 'react';
import { AlertCircle, ArrowLeft, MessageCircle, RefreshCw } from 'lucide-react';

const ACADEMY_URL = 'https://pay.businessbot.ir/link/780536';
const START_WITH_AZI_URL = 'https://pay.businessbot.ir/link/779025';
const SUPPORT_URL = 'https://t.me/fitlinezsupport';

const actions = [
  {
    href: ACADEMY_URL,
    label: 'ادامه ثبت‌نام دوره آکادمی',
    icon: RefreshCw,
    primary: true,
  },
  {
    href: START_WITH_AZI_URL,
    label: 'ادامه پرداخت دوره استارت با آزی',
    icon: ArrowLeft,
  },
  {
    href: SUPPORT_URL,
    label: 'پشتیبانی در تلگرام',
    icon: MessageCircle,
  },
];

export default function PaymentFailed() {
  return (
    <main dir="rtl" className="flex min-h-screen items-center justify-center bg-[#f3efe7] px-5 py-12 text-[#18211f]">
      <section className="w-full max-w-lg rounded-[2rem] border border-[#1c2c29]/10 bg-white/80 p-8 text-center shadow-[0_24px_80px_rgba(28,44,41,0.09)] sm:p-12">
        <div className="mx-auto mb-6 grid h-16 w-16 place-items-center rounded-full bg-[#fff0e8] text-[#c45843]">
          <AlertCircle size={32} strokeWidth={2.25} aria-hidden="true" />
        </div>
        <p className="mb-3 text-sm font-bold text-[#638176]">آکادمی آزی</p>
        <h1 className="text-3xl font-black tracking-tight sm:text-4xl">پرداخت انجام نشد</h1>
        <p className="mx-auto mt-4 max-w-sm text-base leading-8 text-[#5b6561]">
          پرداخت شما ناموفق بود یا کامل نشد. می‌توانید دوباره ادامه دهید یا اگر به راهنمایی نیاز دارید با پشتیبانی تماس بگیرید.
        </p>
        <div className="mt-8 grid gap-3">
          {actions.map(({ href, label, icon: Icon, primary }) => (
            <a
              key={href}
              href={href}
              target="_blank"
              rel="noreferrer"
              className="inline-flex min-h-14 items-center justify-center gap-2 rounded-2xl border border-[#1c2c29]/15 bg-white/70 px-5 py-4 font-bold text-[#1c2c29] transition hover:bg-white focus:outline-none focus:ring-4 focus:ring-[#638176]/15"
            >
              <Icon size={18} aria-hidden="true" />
              {label}
            </a>
          ))}
        </div>
      </section>
    </main>
  );
}
